import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { SettingsGetResult } from '../../models/gen/models';
import { useGenericQuery } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const APPLICATION_SETTINGS_CONTEXT_NAMES = {
  GET_APPLICATION_SETTINGS: 'getApplicationSettings',
} as const;

const apis = apiGenerator();

/**
 * GET `/application-settings`
 *
 * @returns
 */
export const useGetApplicationSettings = () =>
  useGenericQuery(
    [APPLICATION_SETTINGS_CONTEXT_NAMES.GET_APPLICATION_SETTINGS],
    async (_param) =>
      apis.get<void, SettingsGetResult>(
        `${env.BASE_API_ENDPOINT}/application-settings`,
        { ...queryOptions, withoutAuthentication: true }
      ),
    { enabled: true, staleTime: 0 }
  );
